<template>
    <div class="CompleteCourseWarp">
        <!-- 列表数据 -->
        <el-table :data="tableData" style="width: 100%" border :header-cell-style="tableHeaderColor">
            <el-table-column prop="trainCode" label="课程编号" width="150" align="center"></el-table-column>
            <el-table-column prop="trainCourse" label="课程名称" align="center"></el-table-column>
            <el-table-column prop="trainSite" label="培训地点" align="center"></el-table-column>
            <el-table-column prop="startTime" label="课程时间" width="220" align="center"></el-table-column>
            <el-table-column prop="pay" label="培训费用" align="center"></el-table-column>
            <el-table-column prop="endTime" label="课程完成时间" align="center"></el-table-column>
            <el-table-column label="操作" width="200" fixed="right" align="center">
                <template slot-scope="scope">
                    <div class="handle_warp" @click="seecoursrFn(scope.row)">
                        查看
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页 -->
        <div class="paging_warp">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-sizes="[10, 15, 20]"
                :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
        </div>
        <!-- 已完成课程查看 -->
        <FilshCourseModal :isShow.sync="filishVisible" v-if="filishVisible" @filishShowModal='filishShowModal' :currentCourse='currentCourse' />
    </div>
</template>
<script>
import { httpService, srcUrl } from "@/service/httpService";
import FilshCourseModal from './FilshCourseModal'
export default {
    components: {
        FilshCourseModal,
    },
    data() {
        return {
            tableData: [],
            currentPage: 1,
            // 每页显示条数
            pageSize: 10,
            // 总条数
            total: 0,
            filishVisible: false,
            currentCourse:null,
        }
    },
    mounted() {
        this.getList()
    },
    methods: {
        // 获取列表
        async  getList() {
            let params = {
                pageSize: this.pageSize,
                pageCurrent: this.currentPage,
            };
            let data = await httpService.getJoinCourse2(params);
            if (data.code == 200) {
                this.tableData = data.result.list
            }

        },
        // 查看课程
        seecoursrFn(val){
            this.currentCourse=val
            this.filishVisible=true
        },

        tableHeaderColor() {
            return "background-color:#FAFAFA;color:rgba(0,0,0,0.85);border-bottom:1px solid #FAFAFA;font-weight:900;height:55px";
        },
        // 分页
        async handleSizeChange(val) {
            this.pageSize = val;
            this.getList()
        },
        async handleCurrentChange(val) {
            this.currentPage = val;
            this.getList()
        },
        filishShowModal() {

        }
    }

}
</script>
<style lang="less" scoped>
.CompleteCourseWarp {
	.handle_warp {
		// font-size: 18px;
		color: #0083ff;
		cursor: pointer;
		margin: 0 10px;
	}
	.paging_warp {
		text-align: center;
		position: fixed;
		bottom: 40px;
		left: 50%;
	}
}
</style>


